const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getSessionId = () => {
  let sid = sessionStorage.getItem("cc_sid");
  if (!sid) {
    sid = typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("cc_sid", sid);
  }
  return sid;
};

export const trackPageview = () => {
  if (window.location.pathname.startsWith("/admin")) return;
  try {
    fetch(`${API}/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: "pageview",
        path: window.location.pathname,
        referrer: document.referrer || null,
        sid: getSessionId(),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // analytics must never break the site
  }
};
